<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
.public-inp {
  width: 160px !important;
}
.public-fr {
  float: right;
  margin-right: 0;
  margin-left: 5px;
}
.public-screen {
  height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.public-require::before {
  content: "*";
  display: inline-block;
  margin-right: 4px;
  line-height: 1;
  font-family: SimSun;
  font-size: 12px;
  color: #ed4014;
}
.public-page {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
.public-stretch {
  padding: 0 10px;
  cursor: pointer;
  color: #2d8cf0;
  vertical-align: text-bottom;
}
/* vue-treeselect隐藏文件夹icon */
.tree-default-small .tree-themeicon {
  display: none !important;
}
.tree-select,
.tree-select > .tree-select-single {
  border-radius: 4px;
}
.ivu-input-group-prepend {
  background: #fff;
}
.tree-select>.tree-select-single {
  color: #515a6e!important;
  font-size: 12px!important;
}
.tree-select>.tree-selec-allow {
  opacity: 0.3;
}
</style>



// WEBPACK FOOTER //
// src/App.vue